define('views/blocks/AccountOrderView',['app','hooks','underscore', 'jquery', 'backbone',
                'InternalLinkView',
                'SubView',
                'template!blocks/account/order',
                'models/OrderModel',
                'template!blocks/product-block',
                'ProductBlockView',
                'views/blocks/OrderSupportCenterModalView',
                'models/SupportCenterModel'
], function (app, hooks, _, $, Backbone,
                 InternalLinkView,
                 SubView,
                 orderTemplate,
                 OrderModel,
                 productBlockTemplate,
                 ProductBlockView,
                 OrderSupportCenterModalView,
                 SupportCenterModel
    )
    {

        var supportCenterModel;
        function loadSupportCenterModel(){
            if(!supportCenterModel){
                supportCenterModel = SupportCenterModel.getInstance();
            }
            return supportCenterModel;
        }

        return Backbone.View.extend(SubView).extend({
            events: {
                'click .btn-show-detail': 'showDetail',
                'mouseover .btn-show-detail': 'prefetchDetail',
                'click .btn-reorder': 'reorder',
                'click .account-orders .status button': 'showDetail',
                'click .btn-edit': 'editMode',
                'click .invoice': 'downloadInvoice',
                'click .customer-service': 'toggleCustomerServiceDropdown',
                'click .customer-service__order-dropdown button': 'openCustomerService',
                'click .product-line .btn-add ':'addProduct',
                'keypress .edit-content': 'keyAction',
                'click .btn-submit': 'onSubmit'
            },

            initialize: function (options)
            {

                var view = this;
                view.subviews = [];
                view.order = options.order;
                view.target = options.target;
                loadSupportCenterModel();

                function setDefault(key,defaultValue){
                    if (typeof options[key] != 'undefined') {
                        view[key] = options[key];
                    }else{
                        view[key] = defaultValue;
                    }
                }

                setDefault('tracking',false);
                setDefault('trackingdetail',false);
                setDefault('productsdetail',false);
                setDefault('type','normal');
                setDefault('mode','normal');
                setDefault('autoRefreshOrder',false);
                view.render();
            },

            addProduct:function(e)
            {
                var id_product  = $(e.currentTarget).data('id_product'),

                    product = app.getProduct(id_product);

                if(product.isMenu()){
                    app.go('product',{product:product});
                }else{
                   app.getCart().addProduct(product.id);
                }
            },

            reorder:function(){
                var view = this,
                    order = view.order;
                toggleButton(true);
                function toggleButton(loading){
                    view.$('.btn-reorder')
                        .toggleClass('loading',loading)
                        .attr('disabled',loading);
                }
                function onSync(){
                    var cart = app.getCart(),
                        id_cart = order.get('id_cart');
                    if(id_cart){
                        cart.reorder(order).always(function(){
                            toggleButton(false);
                        });
                    }else{
                        app.alert();
                        toggleButton(false);
                    }
                }
                if(order){
                    order.once('sync', onSync);
                    order.fetch();
                }
            },

            prefetchDetail:function(){
                var order = this.order;
                if(order) order.fetch();
            },

            drawProduct: function(product, quantity) {
                if (!_.isUndefined(product) && product.id) {
                    var template = false;
                    hooks.execHook('hookProductLineTemplate', product, function (t) {
                        template = t;
                    });

                    if(!template){
                        template = productBlockTemplate;
                    }

                    return template(
                        {
                            isLogged: app.getCustomer().isLogged(),
                            className:'mobile-inline s-size order-product',
                            wrapCol:true,
                            mobileImageFormat:'block',
                            cart: app.getCart(),
                            product: product,
                            category: null,
                            format: 'account-order',
                            editable: false,
                            ignoreBlockType: true,
                            quantity: quantity
                        }
                    );
                }

                return '<li class="product-col product-block--placeholder order-product "><div class="circle-loader playing"></div></li>'
            },

            showDetail: function (e)
            {
                var view = this,
                    order = view.order;

                function onSync()
                {
                    var html = '', detail = order.getProducts();

                    detail.each(function (orderProduct)
                    {
                        var product  = orderProduct.getProduct()
                        html += view.drawProduct(product, orderProduct.get('quantity'))
                    });
                    var orderline = view.$el;
                    if (orderline.find('.tracking').length) { return }
                    orderline.find('ul.product-container').html(html);
                    view.attachViews(ProductBlockView.initializeProductBlocksOfEl(orderline));

                    var extraPrices = order.get('extraPrice');
                    if(extraPrices.length){
                        var extraPricesHtml = '';
                        _.each(extraPrices,function(extraPrice){
                            if(!extraPrice.free){
                                var price = order.formatExtraPrice(extraPrice.price_ttc)
                                extraPricesHtml += '<span class="order-extra-price">'+extraPrice.name+' '+price+'</span> ';
                            }
                        })
                        view.$('.order-extra-prices').html(extraPricesHtml);
                    }

                }

                if(order){
                    order.once('sync', onSync);
                    order.fetch();
                }

            },

            initOrders: function() {
                var view = this,
                    products = view.order.get('products'),
                    html = '';

                var orderline = view.$el;
                if (!view.productsdetail) { return }
                _(products).each(function(id) {
                    var product = app.getProduct(id);
                    html += view.drawProduct(product)
                });

                orderline.find('ul.product-container').html(html);
                view.attachViews(ProductBlockView.initializeProductBlocksOfEl(orderline));
            },

            onScroll: function() {
                var view = this;

                if (view.fetched) { return }

                var position = view.el.getBoundingClientRect();
                if (position.top > window.innerHeight || position.bottom <= 200) { return }

                view.fetched = true;
                return view.showDetail({currentTarget: view.el});
            },

            keyAction: function(e)
            {
                var code = e.keyCode || e.which;
                if(code == 13) {
                    this.onSubmit();
                }
            },

            editMode: function ()
            {
                var view = this;
                view.$('.order-line').addClass('editable');
                view.$('.order-line .input-title').focus();
            },

            onSubmit: function ()
            {
                var view = this;
                var newVal = view.$('.order-line .input-title').val();
                view.$('.order-line').removeClass('editable');
                view.$('.order-line  .title').text(newVal);
                view.order.set('name' , newVal);
                view.order.save();
            },

	        progessOrderTest : function() {
                var view = this,
                    order = view.order;
                function onSync() {
                    view.render();
                    if (!order.isComplete()) {
                        setTimeout(function () {
                            view.progessOrderTest();
                        }, 60000);
                    }
                }
                order.once('sync', onSync);
                order.remoteFetch();
	        },

            render: function () {
                var view = this;
                view.$el.html(orderTemplate(view));
                view.initOrders();
                view.listenTo(app, 'scroll', view.onScroll);
                setTimeout(view.onScroll.bind(this))
            },

            toggleCustomerServiceDropdown:function(e){
                var view = this,
                    order = view.order,
                    isComplete = !!order && order.isComplete(),
                    dropdown = view.$('.customer-service__order-dropdown'),
                    caret = view.$('.icon-caret-down');
                function ToggleVisible(event){
                    var showDropdown = !dropdown.is('.visible');
                    dropdown.toggleClass('visible',showDropdown);
                    caret.toggleClass('down',showDropdown);
                    if(!showDropdown){
                        app.$window.off('click',ToggleVisible);
                    }else{
                        var dom = '',
                            categories = supportCenterModel.getCategories();
                        categories.forEach(function(category){
                            category.getOrderSections(isComplete).forEach(function(section){
                                section.getArticles().each(function(article){
                                    var id_internal = article.get('id_internal');
                                    dom += '<li><button data-id_internal="'+id_internal+'" data-section="'+section.id+'">'+section.get('name')+'</button></li>'
                                });
                            });
                        });
                        dropdown.find('ul').html(dom);
                        setTimeout(function(){ app.$window.one('click',ToggleVisible) })
                    }
                }
                ToggleVisible(e);
            },

            openCustomerService:function(e){
                var view = this,
                    dataset = e.currentTarget.dataset,
                    id_internal = dataset.id_internal,
                    sectionId = dataset.section;
                new OrderSupportCenterModalView({
                    order:view.order,
                    id_internal:id_internal,
                    sectionId:sectionId
                });
            },

            downloadInvoice: function (e) {
                var view = this,
                 order = view.order;

                if (order.hasInvoice() ){
                    window.location = order.getInvoiceUrl();
                } else {
                    app.confirm({
                        subtitle: app.t('Le téléchargement de cette facture n\'est pas possible. Vous pouvez en faire la demande en ligne.', 'Account'),
                        validation: app.t('Je fais la demande','UI'),
                        cancel: app.t('Non, merci','UI'),
                        }, function(val){
                            if (val) {
                                window.open(app.c('_UNAVAILABLE_ORDER_INVOICE_REDIRECT_LINK_', app.c('_SUPPORT_CENTER_BASE_URL_')), '_blank');
                            }
                    });
                }
            }
        });
    });
